export default __webpack_public_path__ + "7f80bb58815a281b51fd8aa429d41d0b.png";